export const CONSTANTS = {
  BROWSER_LOCATION: {
    COUNTRY: "country",
    LOCALITY: "locality",
  },
  DATE_FORMATS: {
    DAY_MONTH_YEAR_FORMAT: "DD.MM.YYYY",
    DAY_MONTH_YEAR_HYPHEN_FORMAT: "DD-MM-YYYY",
    HOUR_MINUTE_FORMAT: "HH:mm",
    YEAR_MONTH_DAY_HYPHEN_FORMAT: "YYYY-MM-DD",
  },
  HEADER: {
    HEADER: "header",
  },
  HTTP_STATUS: {
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    INTERNAL_SERVER_ERROR: 500,
    INVALID_DATA: 422,
    NOT_FOUND: 404,
    SUCCESS: 200,
    UNAUTHORIZED: 401,
  },
  KEYBOARD_KEYS: {
    ARROW_LEFT: "ArrowLeft",
    ARROW_RIGHT: "ArrowRight",
    BACKSPACE: "Backspace",
    DELETE: "delete",
    ENTER: "Enter",
  },
  LANGUAGES: {
    DE: "DE",
    EN: "EN",
    FR: "FR",
    IT: "IT",
  },
  LOCAL_STORAGE: {
    ACCESS_TOKEN: "ACCESS_TOKEN",
    REFRESH_TOKEN: "REFRESH_TOKEN",
  },
  OTHERS: {
    MORE: "...",
  },
  PHONE_INPUT: {
    MAX_LENGTH: 15,
  },
  RECAPTCHA_INVALID_MESSAGE: {
    EMPTY: "captcha.empty",
    INVALID: "captcha.invalid",
  },
  RECAPTCHA_VERSION: {
    V2: "V2",
    V3: "V3",
  },
  RESERVATION_TABS: {
    CANCELLED: "cancelled",
    FUTURE: "future",
    PAST: "past",
    TODAY: "today",
  },
  STATUS: {
    FAILED: "failed",
    SUCCESS: "success",
  },
  TERMINOLOGY: {
    LOCATION: "Location",
    LOCATIONS: "Locations",
    UNIT: "Unit",
    UNITS: "Units",
  },
  TOAST_TYPE: {
    ERROR: "error",
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
  },
  USER_INFO: {
    INFO: "info",
    MEMBER: "MEMBERS",
    RESERVATIONS: "reservations",
  },
};
